import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";

const groupName = window.location.hostname.slice(
    0,
    window.location.hostname.indexOf(".", 0)
);

const c = encodeURIComponent(Encrypt(groupName));

class JobSettingService {
  getJobResourceField(property, hash) {
    return http.post(`resource-fields/jobs?hash=${hash}&c=${c}`, property);
  }

  getDispatchJobResourceField(property, hash) {
    return http.post(`resource-fields/dispatch-jobs?hash=${hash}&c=${c}`, property);
  }

  getJobCategories(hash, token) {
    return http.get(
      `property-categories?resource=job_categories&hash=${hash}&c=${c}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getDispatchJobCategories(hash, token) {
    return http.get(
        `property-categories?resource=dispatch_job_categories&hash=${hash}&c=${c}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
    );
  }

  getCompanyResourceFields(property, hash) {
    return http.post(`resource-fields/companies?hash=${hash}&c=${c}`, property);
  }

  getCompanyCategories(hash, token) {
    return http.get(
      `property-categories?resource=company_categories&hash=${hash}&c=${c}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getCustomizeTheme(type, hash, token) {
    return http.get(`customize-settings/types/${type}?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  deleteCustomizeTheme(id, hash, token) {
    return http.delete(`customize-settings/${id}?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  deleteRedisData(hash, token) {
    return http.delete(`resource-fields/jobs?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  deleteDispatchRedisData(hash, token) {
    return http.delete(`resource-fields/dispatch-jobs?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  resetDataCompanyInRedis(hash, token) {
    return http.delete(`resource-fields/companies?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default new JobSettingService();
